import { Subject } from 'rxjs';
import { GrouperData } from 'src/contracts/grouperData';
import { EncoderState } from 'src/contracts/encoderState';
import { getEncoderState } from 'src/stores/state-helper';

/**
 * Service that defines MFE contract.
 */
export default {

  setVisitContext$: new Subject<InitData>(),
  addCodes$: new Subject<GrouperData>(),
  setMode$: new Subject<GrouperLayoutMode>(),

  // Called by the host app to set the context in the grouper mfe
  /**
   *
   * @param data
   */
  setContext: function (data: InitData) {
    setTimeout(() => {
      this.setVisitContext$.next(data);
    });
  },

  /**
   * placeholder for method host app will call to auto-add dx or procedure codes to the grouper
   * @param codes
   */
  addCodes: function (codes: GrouperData) {
    this.addCodes$.next(codes);
  },

  /**
   * called by MFE when a request is made to change the mode.
   * TODO: we should rename this to modeChanged so not confusing with setMode
   * @param mode
   */
  // eslint-disable-next-line
  changeMode: function (mode: GrouperLayoutMode, state: EncoderState) {
    console.log(`Request to change to mode: ${mode === GrouperLayoutMode.consolidated ? 'consolidated' : 'fullscreen'}`);
  },

  setMode: function (mode: GrouperLayoutMode) {
    this.setMode$.next(mode);
  },

  /**
   * Function Called by the MFE when a user clicks the X indicating they want to close the grouper.
   */
  // eslint-disable-next-line
  close: function (state: EncoderState) {
    console.log('Request to close the grouper');
  },

  resourcesStateChange: function(open: boolean) {
    console.log(`Resources are open: ${open}`);
  },

  getEncoderState: function(): EncoderState {
    return getEncoderState();
  }
};

export interface InitData {
  endpoint: string;
  facilityCode: string;
  visitId: number;
  dualGrouping: boolean;
  mode: GrouperLayoutMode;
  state?: EncoderState;
  token?: string
  appProfile?: AppProfile;
}

export type AppProfile = 'Concurrent' | 'ImpactTracking' | 'Retrospect';

export enum GrouperLayoutMode {
  consolidated,
  fullScreen
}
